import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class QuestionChoice extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.lblNum = null;
    this.num = null;

    this.bg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._mm_assets_ChoiceBg, this).setOrigin(0);

    this.lblNum = ABCyaPhaser.Text.addText(this.bg.width / 2, this.bg.height / 2, 58, 0x0071BC, FontKeys._BPreplay_Bold, 'X', this, true).setOrigin(0.5);
    ABCyaPhaser.Container.setContainerInteractive(this, true);

    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClick, this);
  }

  onClick () {
    this.emit('CHOICE_SELECT', this);
  }

  showIncorrect () {
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 100, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
  }

  setChoice (num) {
    this.num = num;
    this.lblNum.text = num.toString();
    this.reset();
  }

  reset () {
    this.alpha = 0;
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 1600, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  }
}